const COLOR_ENUM = {
  WARNING: 'warning',
  INFO: 'info',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  BRAND: 'brand',
  MEDIUM: 'medium',
  HIGH: 'high',
  LOW: 'low',
  ON_BRAND: 'on-brand',
  ON_BRAND_HIGH: 'on-brand-high',
  ON_COLOR: 'on-color',
  ON_COLOR_HIGH: 'on-color-high',
  CURRENT_COLOR: 'current-color',
  NEUTRAL: 'neutral'
}

export default COLOR_ENUM
